export default __webpack_public_path__ + "static/media/workflow-stage-lodgement-icon.67f5a215.svg";